import championsLight from '../assets/img/hub-cups/champions-light.webp';
import championsDark from '../assets/img/hub-cups/champions-dark.webp';
import challengeLight from '../assets/img/hub-cups/challenge-light.webp';
import challengeDark from '../assets/img/hub-cups/challenge-dark.webp';
import conferenceLight from '../assets/img/hub-cups/conference-light.webp';
import conferenceDark from '../assets/img/hub-cups/conference-dark.webp';
import asianLight from '../assets/img/hub-cups/asian-light.webp';
import asianDark from '../assets/img/hub-cups/asian-dark.webp';
import europeanLight from '../assets/img/hub-cups/european-light.webp';
import europeanDark from '../assets/img/hub-cups/european-dark.webp';
import libertadoresLight from '../assets/img/hub-cups/libertadores-light.webp';
import libertadoresDark from '../assets/img/hub-cups/libertadores-dark.webp';
import clubworldLight from '../assets/img/hub-cups/clubworld-light.webp';
import clubworldDark from '../assets/img/hub-cups/clubworld-dark.webp';
import supercupLight from '../assets/img/hub-cups/supercup-light.webp';
import supercupDark from '../assets/img/hub-cups/supercup-dark.webp';

export const HUB_CUP_ASSETS = {
  champions: { logoLight: championsLight, logoDark: championsDark },
  challenge: { logoLight: challengeLight, logoDark: challengeDark },
  conference: { logoLight: conferenceLight, logoDark: conferenceDark },
  asian: { logoLight: asianLight, logoDark: asianDark },
  european: { logoLight: europeanLight, logoDark: europeanDark },
  libertadores: { logoLight: libertadoresLight, logoDark: libertadoresDark },
  clubworld: { logoLight: clubworldLight, logoDark: clubworldDark },
  supercup: { logoLight: supercupLight, logoDark: supercupDark },
};
